import React, { useEffect, useState } from 'react'
import useFetchEntitiesWithCache from '../../hooks/useFetchEntitiesWithCache'
import { useAtom } from 'jotai'
import { useFilterIssues } from '../issues/utils'
import { issueFiltersAtom, IssueFilterType } from '../../atoms/issueAtom'
import TrendChart from './trend-chart/TrendChart'
import { useLogUserEvent } from '../../hooks/useLogUserEvent'
import { endOfQuarter, isBefore, subQuarters } from 'date-fns'
import { getIssueDateToFilter } from '../../components/utils/categorizeIssues'
import { USER_EVENT_TYPES } from '@finance-lab/utils/types'

export const TrendsView = () => {
    useLogUserEvent(USER_EVENT_TYPES.SHOW_STATS_TREND_GRAPHS)
    const { isLoading, result: fetchedIssues } = useFetchEntitiesWithCache('issue')
    const [filters, setFilters] = useAtom(issueFiltersAtom)
    const filteredIssues = useFilterIssues(fetchedIssues || [], filters)
    const [oldFilter, setOldFilter] = useState<IssueFilterType | null>(null)

    const today = new Date()
    const endOfLastQuarter = endOfQuarter(subQuarters(today, 1))

    useEffect(() => {
        setFilters((prevFilters) => {
            if (!oldFilter) setOldFilter(prevFilters)

            return {
                ...prevFilters,
                issueTypes: {
                    value: ['Rights issue'],
                    disabledItems: ['Rights issue', 'Directed issue', 'IPO', 'Non-cash issue'],
                },
            }
        })

        return () => {
            if (oldFilter)
                setFilters((filters) => ({
                    ...filters,
                    issueTypes: { ...oldFilter.issueTypes },
                }))
        }
    }, [setFilters, setOldFilter, oldFilter])

    const issuesExludingCurrentQuarter = filteredIssues.filter((issue) =>
        isBefore(getIssueDateToFilter(issue), endOfLastQuarter),
    )

    return <TrendChart isLoading={isLoading} issues={issuesExludingCurrentQuarter} />
}
